export default params => (
  params && Object.keys(params).map(
    name => `${encodeURIComponent(name)}=${encodeURIComponent(params[name])}`,
  ).join('&')
);
